/** @format */

// import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const NotFoundPagePropTypes = exact({});

export default NotFoundPagePropTypes;
